import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import Address from '@/Model/Address';

export default class NavigationStartedMessage extends Message {

    private _canceled: boolean;
    public address: Address;
    public pushState: any;
    public tryToReuse: boolean;
    public isNavigatingBack: boolean;

    public constructor(params: any) {
        super(params);

        this.address = this.paramOrDefault(params.address, null);
        this.pushState = params.pushState;
        this.tryToReuse = params.tryToReuse;
        this.isNavigatingBack = params.isNavigatingBack;

        this._canceled = false;
    }

    public cancel() {
        this._canceled = true;
    }

    public isCanceled() {
        return this._canceled;
    }

    public continue() {
        NavigationService.getInstance().continueNavigation(this);
    }
}

ComponentManager.setMessage('NavigationStartedMessage', NavigationStartedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');